module.exports = __webpack_public_path__ + "img/ita.88d4b319.svg";